var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChangeFlow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 648,
    height: 83,
    viewBox: "0 0 648 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M138.667 49.8C63.833 48.1537 0 83 0 83H648V0C648 0 553.713 47.7163 472 37.848C442.847 34.3273 442.331 26.8392 413.333 23.24C324.776 12.2484 345.468 75.2956 248 71.048C194.648 68.7229 192.619 50.9869 138.667 49.8Z",
    fill: "#009FE3",
    fillOpacity: 0.19
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangeFlow);
export default __webpack_public_path__ + "static/media/changeFlow.cb3427bb764563fb22253e8582dc8ba8.svg";
export { ForwardRef as ReactComponent };